import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { KimRatingGridItemFragmentDoc } from '@packages/gql/generated/shopping/KimRatingGridItemFragmentDoc';
import { ErrorBoundary, Grid, KimRating } from '@packages/shared';
import { useConfig } from '@packages/utilities';

/* GraphQL */ `
  fragment KimRatingGridItem on Product {
    marketcode
  }
`;

export type KimRatingProps = {
  productData: FragmentType<typeof KimRatingGridItemFragmentDoc>;
  referer?: string;
};

export const KimRatingGridItem = ({ productData, referer }: KimRatingProps) => {
  const {
    product: { hasKIM },
  } = useConfig();

  if (hasKIM === false) return null;

  const { marketcode } = getFragmentData(KimRatingGridItemFragmentDoc, productData);

  return (
    <ErrorBoundary>
      <Grid item xs={12}>
        <KimRating
          pageType="detailpage"
          templateParams={{
            x16: `${marketcode ?? 'x'}`,
            x17: referer ?? 'x',
            x19: 'x',
          }}
        />
      </Grid>
    </ErrorBoundary>
  );
};
